import { energyApi } from "utilities/Axios";
export const getAllHealth = () => {
  return energyApi.get("/Health/GetAll");
};

export const refreshHealth = (id: any) => {
  return energyApi.get("/Health/Get" + `?type=${id}`);
};
